import { render, staticRenderFns } from "./buildingBrowseManageList.vue?vue&type=template&id=5ec4fe9e&scoped=true"
import script from "./buildingBrowseManageList.vue?vue&type=script&lang=js"
export * from "./buildingBrowseManageList.vue?vue&type=script&lang=js"
import style0 from "./buildingBrowseManageList.vue?vue&type=style&index=0&id=5ec4fe9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4fe9e",
  null
  
)

export default component.exports